/* eslint-disable */

/**
 * Hotjar Module
 * Handles Hotjar session recording and heatmaps
 */

/**
 * Initialize Hotjar and start recording
 * Only called if user consents to tracking
 */
export function initHotJarAndStartRecording() {
  if (!window.user) {
    return;
  }

  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: 2690383, hjsv: 6 };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");

  hj("trigger", "startRecording");
}
